import { ip_back } from "../config";

function authHeaders(json = true) {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  const headers = {};
  if (token) headers.Authorization = token;
  if (json) headers["Content-Type"] = "application/json";
  return headers;
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

function query({ teId, messageId, videoUrl }) {
  const params = new URLSearchParams();
  if (teId) params.set("te_id", String(teId));
  if (messageId) params.set("message_id", String(messageId));
  if (videoUrl) params.set("video_url", String(videoUrl));
  return params.toString();
}

export async function fetchVideoAnnotations(scope) {
  const qs = query(scope || {});
  if (!qs) return { status: "missing", notes: [] };
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/video-annotations?${qs}`, {
    headers: authHeaders(),
  });
  const body = await parseJson(resp);
  if (!resp.ok || body?.status === false) {
    throw new Error(body?.message || `Annotation load failed (${resp.status})`);
  }
  return body?.data || { status: "missing", notes: [], sessions: [] };
}

export async function saveVideoAnnotations(scope, notes, sessions) {
  const resp = await fetch(`${ip_back}api/mobileAPI/pose/video-annotations`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({
      te_id: scope?.teId || undefined,
      message_id: scope?.messageId || undefined,
      video_url: scope?.videoUrl || undefined,
      notes: Array.isArray(notes) ? notes : [],
      sessions: Array.isArray(sessions) ? sessions : undefined,
    }),
  });
  const body = await parseJson(resp);
  if (!resp.ok || body?.status === false) {
    throw new Error(body?.message || `Annotation save failed (${resp.status})`);
  }
  return body?.data || null;
}
